import React from "react";

import RepeatSettings from "./RepeatSettings";
import VerticalPositionSettings from "./VerticalPositionSettings";

const ImageSettings = props => {
  const { value = "none" } = props.image;
  if (!value || value === "none") return null;

  return (
    <>
      <RepeatSettings {...props} />
      <VerticalPositionSettings {...props} />
    </>
  );
};

export default ImageSettings;
